import React, { useState } from "react";
import { uploadMultipleFilesToFolder } from "../services/folderService";
import { useToast } from "../context/ToastContext";
import "./FileUpload.css";
import { extractErrorMessage } from "../utils/errorUtils";

function FileUpload({ folderId, onSuccess }) {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const { addToast } = useToast();

  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!files.length || !folderId) return;

    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));

    setUploading(true);

    try {
      await uploadMultipleFilesToFolder(folderId, formData);
      addToast("Files uploaded successfully", "success");
      setFiles([]);
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("Upload failed:", err);
      let msg = "Upload failed.";
      if (err?.response?.data?.message?.includes("Maximum upload size exceeded")) {
        msg = "File too large! Please upload smaller files or upload 1 at a time";
      } else {
        msg = await extractErrorMessage(err, "Upload failed.");
      }
      addToast(msg, "error");
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleUpload} className="upload-form">
        <div className="form-row">
          <input
            type="file"
            multiple
            onChange={handleFileChange}
            className="input"
          />
          <button
            type="submit"
            className="btn-primary"
            disabled={!files.length || uploading}
          >
            {uploading
              ? "Uploading..."
              : `📤 Upload${files.length ? ` (${files.length})` : ""}`}
          </button>
        </div>
      </form>
    </>
  );
}

export default FileUpload;
